import React, { useContext, useState } from 'react';
import Purpose from './purpose.js';
import { Switch } from '@warp-ds/react';
import { Action } from '../../common.js';
import { ConsentContext } from '../consent-context.js';

export type LegitimateInterestType = {
    givenLegitimateInterest: LegitimateInterestForUser;
};

export default function LegitimateInterest(
    props: LegitimateInterestType,
): React.ReactElement {
    const consentContext = useContext(ConsentContext);
    const [value, setValue] = useState(
        Action.WITHDRAWN !==
            props.givenLegitimateInterest.userLegitimateInterest?.action,
    );

    const toggle = () => {
        const action = !value ? Action.ACCEPTED : Action.WITHDRAWN;
        consentContext
            .updateLegitimateInterest(props.givenLegitimateInterest, action)
            .then(() => {
                setValue(!value);
            });
    };

    return (
        <Purpose
            purpose={props.givenLegitimateInterest.purpose}
            text={props.givenLegitimateInterest.legitimateInterest.text}
        >
            <Switch
                value={value}
                onClick={toggle}
                aria-label={props.givenLegitimateInterest.purpose.heading}
            />
        </Purpose>
    );
}
